import { ICommandBarItemProps, mergeStyleSets } from "@fluentui/react";
import { Icon } from "@fluentui/react/lib/Icon";
export const IconClassNames = mergeStyleSets({
  whiteBlue: [{ color: "white" }]
});

const getIcon = (iconName: string, className: any) => {
  return <Icon iconName={iconName} className={className}/>;
};

export const _items: ICommandBarItemProps[] = [
  // {
  //   key: "Notifications",
  //   ariaLabel: "Notifications",
  //   // text: "Notifications",
  //   iconProps: { iconName: "Ringer" },
  //   onClick: () => console.log("Notifications"),
  // },
  {
    key: "Help",
    ariaLabel: "Help",
    title: "Help",
    // text: "Help",
    iconProps: { iconName: "Help" },
    onClick: () => console.log("Help"),
  },
];
